import { useRouter } from 'next/router'

import {
  HeaderBar,
  HeaderBarLeftAction,
  HeaderBarTitle,
} from '@wartek-id/header-bar'
import { historyUtils } from '@wartek-id/toolbox-helper'

import { Header as HeaderComponent } from 'components/Header'
import AndroidHandler from 'utils/androidHandler'

const Header = () => {
  const router = useRouter()
  const androidHandler = AndroidHandler()

  if (androidHandler.enabled) {
    return (
      <HeaderComponent
        title="Kelas"
        variant="default"
        hasBackButton={true}
        titlePosition="left"
      />
    )
  }

  return (
    <HeaderBar fixed className="shadow-sm">
      <HeaderBarLeftAction
        onClick={() => historyUtils?.backToApp?.(router?.back)}
      />
      <HeaderBarTitle>Kelas</HeaderBarTitle>
    </HeaderBar>
  )
}

export default Header
